/* ============================================================
   Sudsy Paws — "Aurum" (Apple-style) scroll engine
   Self-contained scrollytelling effects. Touches ONLY decorative
   hooks (`[data-scrub]` pinned chapters, `[data-parallax]` media)
   and never the app.js data-* contract.

   - Pinned chapters: writes scroll progress (0..1) to `--p` on each
     `[data-scrub]` section, plus a triangle `--cap` (peaks mid-scroll)
     for caption cross-fade. CSS maps these to media scale + caption
     opacity (the core apple.com pinned-section effect).
   - Parallax: `[data-parallax]` translateY by its distance from the
     viewport centre (depth via the attribute value, default 12px).
   All effects bail out under prefers-reduced-motion.
   ============================================================ */
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function clamp01(n) {
    return n < 0 ? 0 : n > 1 ? 1 : n;
}
function initScrub() {
    const sections = Array.from(document.querySelectorAll('[data-scrub]'));
    const parallax = Array.from(document.querySelectorAll('[data-parallax]'));
    if (!sections.length && !parallax.length)
        return;
    let ticking = false;
    function update() {
        const vh = window.innerHeight;
        for (const sec of sections) {
            const r = sec.getBoundingClientRect();
            // a tall outer (e.g. 210vh) with a 100vh sticky inner pins for (height - vh).
            const travel = r.height - vh;
            const p = travel > 0 ? clamp01(-r.top / travel) : 0;
            // triangle that peaks at the midpoint so captions fade in then out
            const cap = clamp01(1.4 - Math.abs(p - 0.5) * 3);
            sec.style.setProperty('--p', p.toFixed(4));
            sec.style.setProperty('--cap', cap.toFixed(4));
        }
        for (const el of parallax) {
            const r = el.getBoundingClientRect();
            const centre = r.top + r.height / 2;
            const off = (centre - vh / 2) / vh; // -1..1 across the viewport
            const depth = parseFloat(el.getAttribute('data-parallax') || '12');
            el.style.transform = `translate3d(0, ${(off * depth).toFixed(1)}px, 0)`;
        }
        ticking = false;
    }
    function onScroll() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
}
function boot() {
    if (reduce)
        return;
    initScrub();
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
}
else {
    boot();
}
export {};
